import superAdminApiClient from './superAdminApi.service';
import {
  SuperAdminAuthResponse,
  SuperAdminLoginData,
  SuperAdminSetPasswordData,
  SuperAdminUser,
} from '../types/superAdmin.types';

class SuperAdminAuthService {
  async login(data: SuperAdminLoginData): Promise<SuperAdminAuthResponse> {
    const response = await superAdminApiClient.post<SuperAdminAuthResponse>('/super-admin/auth/login', data);
    return response.data;
  }

  async setPassword(data: SuperAdminSetPasswordData): Promise<SuperAdminAuthResponse> {
    const response = await superAdminApiClient.post<SuperAdminAuthResponse>('/super-admin/auth/set-password', data);
    return response.data;
  }

  async getInvitation(token: string): Promise<SuperAdminAuthResponse> {
    const response = await superAdminApiClient.get<SuperAdminAuthResponse>(`/super-admin/auth/invitations/${token}`);
    return response.data;
  }

  async refreshToken(
    refreshToken: string
  ): Promise<{ accessToken: string; refreshToken: string }> {
    const response = await superAdminApiClient.post('/super-admin/auth/refresh', { refreshToken });
    return response.data.data;
  }

  async logout(): Promise<void> {
    await superAdminApiClient.post('/super-admin/auth/logout');
  }

  async getCurrentUser(): Promise<{ user: SuperAdminUser }> {
    const response = await superAdminApiClient.get('/super-admin/auth/me');
    return response.data.data;
  }

  async requestPasswordReset(email: string): Promise<{ success: boolean; message?: string }> {
    const response = await superAdminApiClient.post('/super-admin/auth/forgot-password', { email });
    return response.data;
  }

  async validateResetToken(token: string): Promise<{ success: boolean }> {
    const response = await superAdminApiClient.get(`/super-admin/auth/reset-password/validate?token=${encodeURIComponent(token)}`);
    return response.data;
  }

  async resetPassword(data: { token: string; password: string; confirm_password: string }): Promise<{ success: boolean }> {
    const response = await superAdminApiClient.post('/super-admin/auth/reset-password', data);
    return response.data;
  }

  saveTokens(accessToken: string, refreshToken: string): void {
    localStorage.setItem('superAdminAccessToken', accessToken);
    localStorage.setItem('superAdminRefreshToken', refreshToken);
  }

  saveUser(user: SuperAdminUser): void {
    localStorage.setItem('superAdminUser', JSON.stringify(user));
  }

  getTokens(): { accessToken: string | null; refreshToken: string | null } {
    return {
      accessToken: localStorage.getItem('superAdminAccessToken'),
      refreshToken: localStorage.getItem('superAdminRefreshToken'),
    };
  }

  getUser(): SuperAdminUser | null {
    const userStr = localStorage.getItem('superAdminUser');
    return userStr ? JSON.parse(userStr) : null;
  }

  clearAuthData(): void {
    localStorage.removeItem('superAdminAccessToken');
    localStorage.removeItem('superAdminRefreshToken');
    localStorage.removeItem('superAdminUser');
  }
}

export default new SuperAdminAuthService();
